<template>
    <div>
        <b-spinner variant="primary" v-if="isLoading"></b-spinner>
        <vue-html2pdf
        v-else
        :show-layout="true"
        :float-layout="false"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="Rapor"
        :pdf-quality="5"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="auto"
        ref="html2Pdf">
            <section slot="pdf-content">
                <div class="reportHeader">
                    <img src="../../../../assets/img/reportLogo.png" class="logo" alt="SanatTeknoloji" width="300" style="padding: 1rem">
                    <div class="info" style="width: 50%">
                        <ul>
                            <li> <strong> Sanat Teknoloji </strong></li>
                            <li> <strong> Adres: </strong> Atakent Mah., Atakan Cad., Öncü Sok. 9/A, 34760 Ümraniye/İstanbul </li>
                            <li> <strong> Telefon: </strong> 0850 259 00 99 </li>
                            <li> <strong> E-posta: </strong> destek@sanatteknoloji.com.tr </li>
                            <li> <strong> Web Sitesi: </strong> <a target="_blank" href="https://sanatteknoloji.com.tr/"> sanatteknoloji.com.tr </a> </li>
                        </ul>
                    </div>
                </div>
                <hr />
                <div class="report-details">
                    <div class="head">
                        <div class="title"> [{{stock.product.barcode}}] {{stock.product.name}} </div>
                        <div class="info">
                            <ul>
                                <li> <strong> Oluşturma Tarihi: </strong> {{moment(stock.created_at)}} </li> 
                                <li> <strong> Düzenlenme Tarihi: </strong> {{moment(stock.updated_at)}} </li> 
                                <li > <strong> İşlem Tarihi: </strong> {{moment(stock.date)}} </li>
                                <li > <strong> İşlem: </strong> {{stock.operation.desc}} </li>
                                <li > <strong> Ürün Adeti: </strong> {{stock.quantity}} </li>
                            </ul>
                        </div>
                        <div v-if="stock.description"> <strong> Açıklama: </strong> {{stock.description}} </div>
                        <div> <strong> Hareket: </strong> {{movementsHistory(stock)}} </div>
                        <hr>
                        <div style="overflow-wrap: break-word;"> <strong> Seri Numaraları: </strong> {{stock.serial_numbers.join(', ')}} </div>


                    </div>
                </div>
            </section>
        </vue-html2pdf>
    </div> 
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import moment from 'moment'

    export default {
        name: "FaultSupportReport",
        props: {
            data: Object,
            modalName: String,
            modalEvent: Function,
            save: Boolean,
            saveState: Function,
            formName: String
        },
        components: {
            VueHtml2pdf
        },
        computed: {
            isLoading() {
                return this.$store.getters.getStockLoading
            },
            stock() {
                return this.$store.getters.getStockMovementDetail
            }
        },
        methods: {
            moment: function (date) {
                return moment(date.substring(0,19)).format('DD MMMM YYYY');
            },
            movementsHistory: function(obj){
                let detail;
                let text = '';
                let tmpData = [["warehouse", "name"], ["to_warehouse", "name"],["customer", "name"]];
                
                    if( obj.type == 'in' || obj.type == 'fault-in'){
                        tmpData = tmpData.reverse()
                    }
                   for(let i = 0; i<tmpData.length; i++){
                        for(let k = 0; k < tmpData[i].length; k++){
                            detail = detail ? detail[tmpData[i][k]] : obj[tmpData[i][k]]
                        }
                        if(detail)
                            text = text == '' ? detail : text+ ' -> ' + detail
                        detail = null
                    }
                
                 return text 
            },
        },
        watch: {
            data() {
                this.$store.dispatch('stockmovements_detail', this.data.id)
            },
            save: async function(data){
                if(data){
                    this.$refs.html2Pdf.generatePdf()
                }
                this.saveState(false)
            },
        },
        mounted() {
            this.$store.dispatch('stockmovements_detail', this.data.id)
        }
    }
</script>

<style lang="css" scoped > 
    @import "../styles/report.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/modals/Detail.vue